import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-to-rebuild-admin"
    }}>{`How to rebuild admin?`}</h1>
    <p>{`When you upload the code to the server as a production, NextJS fetch its code from the build file. So after deployed, when you update or change code on scripts, the updated scripts don't work at admin end until you rebuild the project again. NextJs works this way.`}</p>
    <p>{`Now there are two ways you can follow to rebuild admin,`}</p>
    <p>{`If your server has more than 2+ CPU core and 6GB+ of memory, then you can directly edit code at your server then rebuild the project from the server directly using this command,`}</p>
    <p>{`For `}<inlineCode parentName="p">{`admin,`}</inlineCode></p>
    <p>{`Go to `}<inlineCode parentName="p">{`/var/www/chawkbazar-laravel/admin`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn build
`}</code></pre>
    <p>{`After completing the build, restart the PM2 process using this command,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`pm2 restart 'all'
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`But suppose your server doesn't have that processing power, and you try to build your scripts directly from the server. In that case, your server will be shut down during the build, and you've to restart the server.`}</p>
    </blockquote>
    <p>{`In that case, you can rebuild the admin at your local computer and upload them to your server.`}</p>
    <h2 {...{
      "id": "admin-build-script---run-on-local-pc"
    }}>{`Admin build script - RUN on Local PC`}</h2>
    <blockquote>
      <p parentName="blockquote">{`This is not recommended`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Make sure that your domain name is set in .env file`}</p>
    </blockquote>
    <p><img alt="adminenv.png" src={require("../images/adminenv.png")} /></p>
    <h2 {...{
      "id": "and"
    }}>{`And`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Make sure that your `}<inlineCode parentName="p">{`domain`}</inlineCode>{` and `}<inlineCode parentName="p">{`basePath:\`/admin`}</inlineCode>{` \` is set in next.config.js file`}</p>
    </blockquote>
    <p><img alt="adminconfig.png" src={require("../images/adminconfig.png")} /></p>
    <p>{`Then run the below command from your chawkbazar-laravel project root`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`    zx deployment/rebuildadmin.mjs
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`If your code not upgraded the server then you can try  `}<a parentName="p" {...{
          "href": "/faq#how-to-rebuild-the-project"
        }}>{`manual process`}</a>{` or other. Becouse we don't recommended this process.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      